import { render, staticRenderFns } from "./FieldEntityProduct.vue?vue&type=template&id=3710a5ba&"
import script from "./FieldEntityProduct.vue?vue&type=script&lang=js&"
export * from "./FieldEntityProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports